import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'
import { pageSeo } from '@/lib/seo'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { useAppForm } from '@/lib/use-app-form'
import { PasswordAuthLayout } from '@/routes/_app/-components/shared/password-auth-layout'
import { AuthPending } from '@/routes/_app/-components/app-layout-skeleton'
import { useMutation } from '@tanstack/react-query'
import { toast } from '@/lib/toast'
import { trpc } from '@/main'

export const Route = createFileRoute('/_public/begin-password-reset')({
  // A stable URL, so it keeps a canonical — but a form that only emails a link is a step in a flow, not a page.
  head: (ctx) =>
    pageSeo(ctx, {
      path: '/begin-password-reset',
      title: msg`Reset password`,
      description: msg`Enter the email address associated with your account and we will send you a link to reset your password.`,
      noindex: true,
    }),
  component: RouteComponent,
  pendingComponent: AuthPending,
})

function RouteComponent() {
  const { t } = useLingui()
  const { mutateAsync: beginPasswordReset } = useMutation(trpc.auth.beginPasswordReset.mutationOptions())

  const form = useAppForm({
    validators: { onChange: v.object({ email: v.pipe(v.string(), v.email()) }) },
    defaultValues: { email: '' },
    onSubmit: async ({ value }) => {
      await beginPasswordReset(value.email)
      const email = value.email
      toast.success(
        t`If this account exists, you will receive an email to ${email} with the steps to follow to reset your password.`,
      )
    },
  })

  return (
    <PasswordAuthLayout
      title={t`Reset password`}
      subtitle={t`Enter the email address associated with your account and we will send you a link to reset your password.`}
    >
      <form
        onSubmit={(event) => {
          event.preventDefault()
          form.handleSubmit()
        }}
        className="flex flex-col gap-3"
      >
        <form.AppField name="email" children={(field) => <field.TextField label={t`Email`} type="email" />} />
        <form.AppForm>
          <form.SubmitButton label={t`Send`} />
        </form.AppForm>
      </form>
    </PasswordAuthLayout>
  )
}
